(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("custom-ui", [], factory);
	else if(typeof exports === 'object')
		exports["custom-ui"] = factory();
	else
		root["custom-ui"] = factory();
})(window, function() {
return 